﻿$.fn.dxCtrlContentEnvoiMailingObjet = function custom_dxCtrlContentEnvoiMailingObjet(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingobjet dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingObjet(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingObjet = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    //var $InputObjetEmoji = null
    //var timeOutChange = null
    var dx = null
    function mConstruit() {
        container.empty()
        container.css("width", "100%")
        if (option.data.objet == null) option.data.objet = ""

        dx = $("<div/>").appendTo(container).dxCtrlTxtObjet({
            showPersonnalisation:true,
            value: option.data.objet,
            placeholder:"objet...",
            onValueChanged: function (value) {
                mSaveObjet()
            }
        }).dxCtrlTxtObjet("instance")
        //$InputObjetEmoji = $("<input placeholder='Objet...' style='" + ((!option.objetVisible) ? "display:none;" : "") + "'></input>").appendTo(container)
        //$InputObjetEmoji.emojioneArea({
        //    pickerPosition: "top",
        //    value: option.data.objet,
        //    tonesStyle: "bullet",
        //    searchPlaceholder: "Rechercher...",
        //    events: {
        //        onLoad: function () {
        //            var oldValue = option.data.objet
        //            function mSurveilleChangeObjet() {
        //                if (container.closest("body").length = 0) return
        //                if (oldValue != mGetTextObjet()) {
        //                    oldValue = mGetTextObjet()
        //                    window.clearTimeout(timeOutChange)
        //                    timeOutChange = window.setTimeout(function () { mSaveObjet() }, 500)
        //                }
        //                window.setTimeout(function () { mSurveilleChangeObjet() }, 1000)
        //            }
        //            window.setTimeout(function () {
        //                $InputObjetEmoji = $InputObjet[0].emojioneArea
        //                $InputObjetEmoji.setText(option.data.objet)
        //                mSurveilleChangeObjet()
        //                //window.setTimeout(function () { Me.focus() }, 300)
        //            }, 0)
        //        }
        //    }
        //});

        var $DivTot = $("<div style='margin:30px'/>").appendTo(container)
        $("<div style='margin:5px;'>&bull; En général, ce sont les objets de moins de 9 mots qui donnent le meilleur résultat.</div>").appendTo($DivTot)
        //$("<div style='margin:5px;'>&bull; N'abusez pas des émojis. Un seul suffit.</div>").appendTo($DivTot)
        $("<div style='margin:5px;'>&bull; Limitez vous à 60 caractères pour être concis.</div>").appendTo($DivTot)
    }

    function mSaveObjet() {
        option.bddCtrl.mAjaxCall({
            command: "savedataemailobjet_data",
            objet: mGetTextObjet(),
            nom_table: "com_email_envoi",
            id:option.data.id_com_email_envoi
        })
        option.data.objet = mGetTextObjet()
        option.bddCtrl.getObjet(option.data).mSaveChamp("objet")
        option.onChange()
    }

    function mGetTextObjet() {
        //var value = $InputObjetEmoji.getText()
        //if (value.length > 0 && value.charCodeAt(value.length - 1) > 255) value += "  "
        //return value
        return dx.mGetValue()
    }

    this.element = function () { return container }

    mConstruit();
}